import type {NavigateFunction} from 'react-router';

import eventMessagesService from '@/services/events/eventMessagesService';

let navigateFn: NavigateFunction | null = null;
let currentDepth = 0;

export const setNavigate = (fn: NavigateFunction) => {
    navigateFn = fn;
};

export const setNavigationDepth = (depth: number) => {
    currentDepth = depth;
};

const forwardTo = (path: string) => navigateFn?.(path);

const goBack = () => {
    if (currentDepth === 0) eventMessagesService.sendBackButtonTriggerMessage();
    else navigateFn?.(-1);
};

const replace = (path: string) => navigateFn?.(path, {replace: true});

export default {forwardTo, goBack, replace};
